import { render, staticRenderFns } from "./ManagerDashboard.vue?vue&type=template&id=36236cc8&scoped=true"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"
import style0 from "./ManagerDashboard.vue?vue&type=style&index=0&id=36236cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36236cc8",
  null
  
)

export default component.exports